import { TFaqInfo } from "types/operation";

export const FAQData: TFaqInfo[] = [
    {
        id: 1,
        pageId: 1,
        seq: 1,
        question: "1. What is Klarity Meet?",
        answer: `<b>Answer:</b> Klarity Meet is Klarity’s built-in, HIPAA-secure video visit system. It lives directly inside your Klarity Provider Portal and Patient Portal, so you can run telehealth visits without external video tools, copied links, or extra logins.`,
    },
    {
        id: 2,
        pageId: 2,
        seq: 2,
        question: '2. Do I need to download software or install anything?',
        answer: `<b>Answer:</b> No. Klarity Meet is 100% browser-based. Both you and your patient join from any modern browser on desktop, tablet, or mobile—no downloads required.`,
    },
    {
        id: 3,
        pageId: 3,
        seq: 3,
        question: '3. Is Klarity Meet HIPAA compliant?',
        answer: `<b>Answer:</b> Yes. Klarity Meet is designed for healthcare use with encrypted video/audio, authenticated access, and audit logging. Only logged-in providers and patients can join sessions—even if a meeting link is shared.`,
    },
    {
        id: 4,
        pageId: 4,
        seq: 4,
        question: '4. How are video links generated and shared?',
        answer: `<b>Answer:</b> Every telehealth appointment automatically gets a unique Klarity Meet link. The link is included in the patient’s standard Klarity email and SMS reminders—no manual copy-paste needed.`,
    },
    {
        id: 5,
        pageId: 5,
        seq: 5,
        question: '5. Can patients join early?',
        answer: `<b>Answer:</b> Yes. Patients can join the virtual waiting room before you arrive. You’ll see when they’re waiting and admit them when you’re ready—similar to a physical clinic flow.`,
    },
    {
        id: 6,
        pageId: 6,
        seq: 6,
        question: '6. What happens if a patient has poor internet?',
        answer: `<b>Answer:</b> Klarity Meet automatically adapts video and audio quality based on network conditions. If bandwidth is limited, the system prioritizes audio to keep the visit usable.`,
    },
    {
        id: 7,
        pageId: 7,
        seq: 7,
        question: '7. Can I use Klarity Meet inside my existing workflow?',
        answer: `<b>Answer:</b> Yes. The video window is embedded directly inside your Provider Portal and can expand to full screen if needed. You can review intake answers, chart, and manage care without switching tools.`,
    },
    {
        id: 8,
        pageId: 8,
        seq: 8,
        question: '8. Does Klarity Meet support screen sharing?',
        answer: `<b>Answer:</b> Yes. You can share your entire screen or a browser tab during the visit—useful for education, labs, imaging, or care plans.`,
    },
    {
        id: 9,
        pageId: 9,
        seq: 9,
        question: '9. Is there in-visit chat?',
        answer: `<b>Answer:</b> Yes. Klarity Meet includes in-session text chat with the patient. Messages can be stored and synced into your existing Klarity in-app messaging and documentation workflows.`,
    },
    {
        id: 10,
        pageId: 10,
        seq: 10,
        question: '10. Are group visits supported?',
        answer: `<b>Answer:</b> One-to-one visits are the default. Group sessions (multiple participants) will be supported in the future based on your clinic’s needs. Please reach out to Klarity provider support team if you are interested. `,
    },
    {
        id: 11,
        pageId: 11,
        seq: 11,
        question: '11. What data is logged for compliance?',
        answer: `<b>Answer:</b> Klarity Meet records audit-level metadata such as session start/end times and participant join times. This supports compliance and operational review without recording video by default.`,
    },
    {
        id: 12,
        pageId: 12,
        seq: 12,
        question: '12. What do patients see while waiting?',
        answer: `<b>Answer:</b> While waiting, patients may complete short pre-visit surveys (health goals, habits, wellness check-ins). Their responses are saved to the patient record and can be surfaced to you before or during the visit.`,
    },
    {
        id: 13,
        pageId: 13,
        seq: 13,
        question: '13. Does Klarity Meet include transcription or captions?',
        answer: `<b>Answer:</b> Real-time AI captions and transcription are part of the Klarity Meet roadmap. They'll be released in 2026.. When enabled, transcripts will be stored in appointment history and accessible via the patient portal.`,
    },

    {
        id: 14,
        pageId: 14,
        seq: 14,
        question: '14. What happens after the visit ends?',
        answer: `<b>Answer:</b> Immediately after the appointment, patients are prompted to rate their experience (1–5 stars with optional comments). This helps you collect feedback quickly and identify issues early.`,
    },
    {
        id: 15,
        pageId: 15,
        seq: 15,
        question: '15. What if a patient leaves before submitting feedback?',
        answer: `<b>Answer:</b> If the patient closes the browser without dismissing the survey, it will reappear the next time they return and also share with patient's email. If they explicitly dismiss it, they won’t be prompted again.`,
    },
    {
        id: 16,
        pageId: 16,
        seq: 16,
        question: '16. Can I keep using my existing video tool?',
        answer: `<b>Answer:</b> Yes. Klarity Meet does not force a full switch. You can select Klarity Meet as your default platform and still use a custom video link for individual appointments if needed.`,
    },
    {
        id: 17,
        pageId: 17,
        seq: 17,
        question: '17. How much does Klarity Meet cost?',
        answer: `<b>Answer:</b> Klarity Meet is free for providers on Klarity. There are no per-visit video fees, licenses, or hidden usage charges.`,
    },
    {
        id: 18,
        pageId: 18,
        seq: 18,
        question: '18. How do I turn Klarity Meet on?',
        answer: `<b>Answer:</b> Log into your Klarity Provider Portal, go to Settings → Video visit, select Klarity Meet (Recommended), and save. Your next telehealth appointment will automatically generate a Klarity Meet link.`,
    },
];